// extracted by mini-css-extract-plugin
export default {"todoContainer":"TodoList_todoContainer__dF8D9","todoList":"TodoList_todoList__PdFfR"};